module.exports = __webpack_public_path__ + "static/media/paper.c45d3ee4.svg";